export default __webpack_public_path__ + "6e961c0272b6286cafa2afbffbcc8b33.svg";